import React, { useEffect, useState } from "react";
import useDataSourceManager from "hooks/useDataSourceManager";
import { useAuth } from "contexts/AuthContext";
import { useSearchParams, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import ControllerInvition from "./Invitation";
import ControllerError from "./Error";
import ControllerExpired from "./Expired";
import ControllerInvalid from "./Invalid";

const UserManagementController = () => {
  const [invitationUuid] = useState(uuidv4());
  const [status, setStatus] = useState(""); // "invitation", "error", "expired", "exist"

  const { token, redirectPathCode } = useAuth();
  const [searchParams] = useSearchParams();
  const vIdFromUrl = searchParams.get("v_id");
  const vId = vIdFromUrl || sessionStorage.getItem("pendingInvitationId");
  const navigate = useNavigate();
  const { dataMap, getData, decodeTokenData, sendRequest, sendBatch } =
    useDataSourceManager();

  useEffect(() => {
    if (vIdFromUrl) {
      sessionStorage.setItem("pendingInvitationId", vIdFromUrl);
      return;
    }

    if (redirectPathCode && !vIdFromUrl) {
      sessionStorage.setItem("pendingInvitationId", redirectPathCode);
      const params = new URLSearchParams(window.location.search);
      params.set("v_id", redirectPathCode);
      navigate(`${window.location.pathname}?${params.toString()}`, {
        replace: true,
      });
    }
  }, [redirectPathCode, vIdFromUrl, navigate]);
  useEffect(() => {
    if (token && vId) {
      sendRequest("/me/invitations/:invitationId.read", invitationUuid, {
        invitationId: vId,
      });
    }
  }, [token, vId, invitationUuid]);

  useEffect(() => {
    const meReadResponse = getData(invitationUuid);
    if (meReadResponse?.data) {
      const { email, invitationId, organizationName } = meReadResponse.data;
      localStorage.setItem("invitationEmail", email);
      localStorage.setItem("invitationId", invitationId);
      localStorage.setItem("organizationName", organizationName);
      sessionStorage.removeItem("pendingInvitationId");
      setStatus("invitation");
    } else if (meReadResponse?.code === 422) {
      sessionStorage.removeItem("pendingInvitationId");
      setStatus("error");
    } else if (meReadResponse?.code === 404) {
      sessionStorage.removeItem("pendingInvitationId");
      setStatus("invalid");
    } else if (meReadResponse?.code === 400) {
      sessionStorage.removeItem("pendingInvitationId");
      setStatus("expired");
    }
  }, [dataMap]);

  if (status === "invitation") return <ControllerInvition />;
  if (status === "error") return <ControllerError />;
  if (status === "expired") return <ControllerExpired />;
  if (status === "invalid") return <ControllerInvalid />;

  return null;
};

export default UserManagementController;
